import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Main from './components/Main/Main';
import ServerError from './components/Errors/ServerError/ServerError';
import { isWindowVisible, setSocketContext } from './store/actions/socketAction';
import socket from './utils/socket';
import { roundNumber } from './utils/formatDecimal';
import LocalStorage, { LOCAL_STORAGE_KEYS } from './utils/localStorage';
import { changeLocale, changeTheme } from './store/actions/settings';
import ErrorBoundary from './components/Errors/ErrorBoundary/ErrorBoundary';
import { removeMoreMarketsRedirectUrl, setDatePickerLocale } from './utils/helpers';
import { getMarketGroups } from './store/actions/markets';
import { IS_PROD, MARKET_GROUP_STATUSES } from './constants/defaultValues';
import AppVersion from './components/shared/Toasts/AppVersion/AppVersion';
import { fetchAppVersion } from './store/actions/global';
import { loginDevice } from './store/actions/auth';
import HomePage from './components/HomePage/HomePage';
import SocketUpdater from './components/shared/SocketUpdater/SocketUpdater';
import { fetchTranslationsList } from './store/actions/translations';
import Routes from './Routes';
import deviceSocket from './utils/device-socket';
import { identifyLogRocketUser } from './utils/logrocket';

setDatePickerLocale();

removeMoreMarketsRedirectUrl();

window.trimNum = (num, noMinus = true) => {
    // const trimmed = currJs(num).value;
    if (num < 0 && noMinus) return '0.00';
    return roundNumber(num, 2);
};

const App = props => {
    const dispatch = useDispatch();

    const { isAuthenticating, isAuthenticated, cashierInfo } = useSelector(state => state.auth);
    const { locale, theme } = useSelector(state => state.settings);

    useEffect(() => {
        deviceSocket.emit('context.updated', { isProd: IS_PROD, language: locale });

        window.onfocus = () => {
            deviceSocket.emit('context.updated', { isProd: IS_PROD, language: locale });
            dispatch(isWindowVisible(true));
        };

        window.onblur = () => dispatch(isWindowVisible(false));

        dispatch(loginDevice());
        dispatch(fetchAppVersion());

        dispatch(fetchTranslationsList());

        const lang = LocalStorage.getItem('lang');
        if (lang) {
            dispatch(changeLocale(lang));
        }

        const userThemePreference = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.theme));
        dispatch(changeTheme(userThemePreference));
    }, []);

    useEffect(() => {
        if (isAuthenticating) return;

        if (isAuthenticated) {
            const context = {
                userId: cashierInfo.terminalCode,
                client: 'ssbt',
            };
            dispatch(setSocketContext(context));
            dispatch(getMarketGroups({ status: MARKET_GROUP_STATUSES.active }));

            identifyLogRocketUser(cashierInfo.terminalCode, { id: cashierInfo.id });
            socket.connect();
        } else {
            socket.disconnect();
        }
    }, [isAuthenticating, isAuthenticated]);

    useEffect(() => {
        if (theme) {
            document.body.classList.add('theme-light');
        } else {
            document.body.classList.remove('theme-light');
        }
    }, [theme]);

    return (
        <Router>
            <ErrorBoundary>
                <AppVersion />
                <SocketUpdater />
                <Routes />
            </ErrorBoundary>
        </Router>
    );
};

export default App;
